import React, { Component } from 'react'
import Api from '../../api'
import TextField from '../TextField'
import PasswordField from '../PasswordField'


export default class LoginWithEmail extends Component {
  api = new Api()
  state = {
    email: "",
    password: "",
    errors: {},
    loading: false
  }


  handleSubmission = (e) => {
    e.preventDefault()
    this.setState({loading: true})
    const { email, password } = this.state
    this.api.loginWithEmail(email, password, (errors) => this.setState({errors, loading: false}))
  }

  render() {
    const { email, password, errors, loading } = this.state

    return (
      <form onSubmit={this.handleSubmission}>
        { errors.base && <div className="base-errors">{ errors["base"] }</div> }

        <TextField
          placeholder="Enter your email"
          value={email}
          onChange={email => this.setState({email})}
          error={errors.email}
        />

        <PasswordField
          placeholder="Password"
          value={password}
          onChange={password => this.setState({password})}
          error={errors.password}
        />

        <p className="login__form__signup__link">
          Don't have an account yet. <a href="https://www.catholicsingles.com/join/">Sign up</a> first.
        </p>
        <input type="submit" value="Login with Email" disabled={loading} className={`login__form__submit ${loading ? 'loading' : ''}`} />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginWidget/LoginWithEmail.js